import { BaseService } from 'src/app/core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { NotificationService } from '@optsolservices/ngx-notification';

@Component({
  selector: 'app-sales-order-header-customer-details-dialog',
  templateUrl: './sales-order-header-customer-details-dialog.component.html',
  styleUrls: ['./sales-order-header-customer-details-dialog.component.scss']
})
export class SalesOrderHeaderCustomerDetailsDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<SalesOrderHeaderCustomerDetailsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
  ) {
    this.form = fb.group({
      salesOrderHeaderId: [null, Validators.compose([])],
      salesOrderNumber: [null, Validators.compose([])],
      customerName: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      companyTaxNumber: [null, Validators.compose([Validators.maxLength(15)])],
      email: [null, Validators.compose([Validators.email, Validators.maxLength(255)])],
      shipToAddr1: [null, Validators.compose([Validators.maxLength(40)])],
      shipToAddr2: [null, Validators.compose([Validators.required, Validators.maxLength(40)])],
      shipToAddr3: [null, Validators.compose([Validators.required, Validators.maxLength(40)])],
      shipToAddr4: [null, Validators.compose([Validators.required, Validators.maxLength(40)])],
      shipToAddr5: [null, Validators.compose([Validators.required, Validators.maxLength(40)])],
      shipPostalCode: [null, Validators.compose([Validators.required, Validators.maxLength(10)])],
      shipToGpsLat: [null, Validators.compose([Validators.min(-90), Validators.max(90)])],
      shipToGpsLong: [null, Validators.compose([Validators.min(-180), Validators.max(180)])],
    });

    if (this.data.isCashCustomer === true) {
      this.form.controls['shipToAddr1'].clearValidators();
      this.form.controls['shipToAddr1'].setValidators(Validators.compose([Validators.maxLength(40)]));
      this.form.controls['shipToAddr1'].updateValueAndValidity();

      this.form.controls['shipToAddr2'].clearValidators();
      this.form.controls['shipToAddr2'].setValidators(Validators.compose([Validators.maxLength(40)]));
      this.form.controls['shipToAddr2'].updateValueAndValidity();

      this.form.controls['shipToAddr3'].clearValidators();
      this.form.controls['shipToAddr3'].setValidators(Validators.compose([Validators.maxLength(40)]));
      this.form.controls['shipToAddr3'].updateValueAndValidity();

      this.form.controls['shipToAddr4'].clearValidators();
      this.form.controls['shipToAddr4'].setValidators(Validators.compose([Validators.maxLength(40)]));
      this.form.controls['shipToAddr4'].updateValueAndValidity();

      this.form.controls['shipToAddr5'].clearValidators();
      this.form.controls['shipToAddr5'].setValidators(Validators.compose([Validators.maxLength(40)]));
      this.form.controls['shipToAddr5'].updateValueAndValidity();

      this.form.controls['shipPostalCode'].clearValidators();
      this.form.controls['shipPostalCode'].setValidators(Validators.compose([Validators.maxLength(10)]));
      this.form.controls['shipPostalCode'].updateValueAndValidity();
    }

    if (this.data.postalCodeOptional) {
      this.form.controls['shipPostalCode'].clearValidators();
      this.form.controls['shipPostalCode'].setValidators(Validators.compose([Validators.maxLength(10)]));
      this.form.controls['shipPostalCode'].updateValueAndValidity();
    }
  }

  ngOnInit() {
    this.form.patchValue(this.data);
  }

  save() {
    if (this.data.mode === 'SYSPRO') {
      const dialogData: OiGroupDialogData = {
        title: 'Updating Customer Details In SYSPRO',
        function: 'portal_oi_group_syspro_order_customer_details_modify',
        postBody: {
          ...this.form.getRawValue()
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('Customer Details Updated In Syspro');
          this.dialogRef.close(true);
        }
      });

    } else {
      this.baseService.executeCommand<any[]>('portal_sales_order_header_customer_details_modify', this.form.getRawValue())
        .subscribe(response => {
          if (response.responseCode === 0) {
            this.dialogRef.close(true);
          }
        });
    }
  }
}
